/* eslint-disable max-len */
export default {
  en: {
    issue_create_title: 'Create issue',
    issue_edit_title: 'Edit issue',
    issue_description: 'Describe your problem | Tell us about the problem you are facing, or just create a task.',
    issue: 'Problem | Problems | No problems',
    issue_create: 'Create a problem | created a problem',
    discussion: 'Discussion | Discussions',
    discussion_no: 'There are no discussions',
    discussion_closed: 'The discussion is closed',
    issueDelete: 'Delete Issue',
    cancel: 'Cancel',
    delete: 'Delete',
    writeCommentTitle: 'Write your comment here',
    issueDeleteConfirmation: 'Are you sure you want to delete the problem?',
    issueNameLabel: 'Title',
    issue: {
      create: 'Create Issue',
      save: 'Save Issue'
    },
    search: 'Search by issue title',
    issue_assigned_to_me: 'assigned to me',
    issues_none: 'No issues yet. Create the first one using | documentation',
    issue_title: 'Issue title',
    issue_description_title: 'Issue description',
    linked_merge_requests: 'Linked merge requests',
    disscussion_none: 'No comments yet. Be the first to leave a comment.',
    assign_assigners: 'Assign assigners',
    link_request: 'Link to new merge request',
    link_issue_to_request: 'Link issue to new merge request',
    add_labels: 'Add lables',
    select_merge_request: 'Select merge request'
  },
  ru: {
    issue_create_title: 'Создание проблемы',
    issue_edit_title: 'Редактирование проблемы',
    issue_description:
      'Опишите свою проблему | Расскажите о проблеме, с которой вы столкнулись, или просто создайте задачу.',
    issue: 'Проблема | Проблемы | Нет проблем',
    issue_create: 'Создать проблему | создал(а) проблему',
    discussion: 'Обсуждение | Обсуждения',
    discussion_no: 'Нет дискуссий',
    discussion_closed: 'Дискуссия закрыта',
    issueDelete: 'Удалить проблему',
    cancel: 'Отменить',
    delete: 'Удалить',
    writeCommentTitle: 'Напишите комментарий здесь',
    issueDeleteConfirmation: 'Вы уверены, что хотите удалить проблему?',
    issueNameLabel: 'Название',
    issue: {
      create: 'Создать проблему',
      save: 'Сохранить проблему'
    },
    search: 'Поиск по названию проблемы',
    issue_assigned_to_me: 'назначена на меня',
    issues_none: 'Проблем еще нет. Создайте первую, использовав | документацию',
    issue_title: 'Название проблемы',
    issue_description_title: 'Описание проблемы',
    linked_merge_requests: 'Связанные запросы на слияние',
    disscussion_none: 'Комментариев еще нет. Будьте первым, кто оставит комментарий.',
    assign_assigners: 'Назначьте отвественных',
    link_request: 'Связать с новым запросом на слияние',
    link_issue_to_request: 'Связать проблему с новым запросом на слияние ',
    add_labels: 'Добавьте лейблы',
    about: 'Подробнее про функционал проблем',
    select_merge_request: 'Выберите запрос на слияние'
  }
};
